export const T = {
  en_GB: {
    edit: "Edit",
    delete: "Delete",
    productName: "Product Name",
    productType: "Product Type",
    minRiskLevel: "Min Risk Level",
    minRiskScore: "Min Risk Score",
    minTimeHorizon: "Min Time Horizon",
    actions: "Actions",
    noProducts: "No products yet.",
    noProductsMatch: "No products match your search",
    notSet: "—",
  },
  nb_NO: {
    edit: "Rediger",
    delete: "Slett",
    productName: "Produktnavn",
    productType: "Produkttype",
    minRiskLevel: "Min. risikonivå",
    minRiskScore: "Min. risikoscore",
    minTimeHorizon: "Min. tidshorisont",
    actions: "Handlinger",
    noProducts: "Ingen produkter ennå.",
    noProductsMatch: "Ingen produkter samsvarer med søket",
    notSet: "—",
  },
} as const;
